import { ReactNode, useMemo } from 'react'

import { SxProps, Theme } from '@mui/material'

import {
  ControlledMultipleAutocomplete,
  IMultipleAutocompleteOption,
} from 'components/common/controller-wrapper'
import { useGetXeroCodesQuery } from 'generated/graphql'

interface IProps {
  control: any
  name: string
  label?: string
  defaultValue?: IMultipleAutocompleteOption[]
  limitTags?: number
  size?: 'small' | 'medium'
  sx?: SxProps<Theme>
  noOptionsText?: ReactNode
}

export const XeroCodeMultipleAutocomplete = ({
  control,
  name,
  label = 'Service code',
  defaultValue = [],
  limitTags,
  size,
  sx,
  noOptionsText,
}: IProps) => {
  const { data: xeroCodesData } = useGetXeroCodesQuery({
    fetchPolicy: 'cache-first',
  })

  const options = useMemo(
    () =>
      xeroCodesData?.xeroCodes
        ? xeroCodesData?.xeroCodes.map((c) => ({ value: c.id, label: c.name }))
        : [],
    [xeroCodesData],
  )

  return (
    <ControlledMultipleAutocomplete
      control={control}
      name={name}
      label={label}
      options={options}
      defaultValue={defaultValue}
      limitTags={limitTags}
      size={size}
      sx={sx}
      noOptionsText={noOptionsText}
    />
  )
}
